import i18n from '@/i18n'
import { SUPPORTED } from '@/i18n'

const SITE = (process.env.VUE_APP_SITE_URL || window.location.origin).replace(/\/$/, '')

function setTag(selector, create, attrs) {
  let el = document.head.querySelector(selector)
  if (!el) { el = document.createElement(create); document.head.appendChild(el) }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v))
  return el
}

function urlFor(lang, path) {
  return `${SITE}/${lang}${path ? '/' + path : '/'}`
}

// Title, description, canonical, hreflang and robots for the current route, in the current language.
export function applySeo(to) {
  const lang = to.params.lang
  if (!lang || !to.meta.seo) return
  const t = i18n.global.t
  const key = to.meta.seo
  document.title = t(`meta.${key}.title`)
  setTag('meta[name="description"]', 'meta', { name: 'description', content: t(`meta.${key}.description`) })

  // path after /<lang>/ , e.g. "explore", "" or "view/12"
  const rest = to.path.replace(new RegExp(`^/${lang}/?`), '')
  setTag('link[rel="canonical"]', 'link', { rel: 'canonical', href: urlFor(lang, rest) })

  document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((n) => n.remove())
  SUPPORTED.forEach((l) => {
    const el = document.createElement('link')
    el.rel = 'alternate'; el.hreflang = l; el.href = urlFor(l, rest)
    document.head.appendChild(el)
  })
  const x = document.createElement('link')
  x.rel = 'alternate'; x.hreflang = 'x-default'; x.href = urlFor('en', rest)
  document.head.appendChild(x)

  if (to.meta.index) {
    const r = document.head.querySelector('meta[name="robots"]'); if (r) r.remove()
  } else {
    setTag('meta[name="robots"]', 'meta', { name: 'robots', content: 'noindex' })
  }
}
